import { createFileRoute, redirect } from "@tanstack/react-router"
import { FALLBACK_LOCALE } from "@holigral/shared/i18n"

// Bare "/" is redirected to the locale home server-side: Caddy routes "/" to
// Symfony (LocaleRedirectController), which negotiates the locale from
// Accept-Language (q-aware) — see devops/docker/frankenphp/*/Caddyfile. This
// route exists only so the prerender build has a root and direct-to-Vite dev
// access still resolves; it forwards to the default locale, which the
// server-side redirect overrides for real requests.
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/$locale", params: { locale: FALLBACK_LOCALE } })
  },
})
